import React from "react";
import { useStore } from "@/context/StoreContext";
import { waLink } from "@/lib/api";

export default function WhatsAppFloat() {
  const { content } = useStore();
  const msg = content?.whatsapp_cta?.text
    ? `Olá, Art3D! ${content.whatsapp_cta.text}`
    : "Olá, Art3D! Vim pelo site e quero saber mais sobre os produtos.";
  return (
    <a
      href={waLink(content, "Olá, Art3D! Vim pelo site e quero saber mais sobre os produtos.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-5 right-5 z-40 group flex items-center gap-0 bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-full shadow-lg shadow-green-500/30 transition-all duration-300 hover:gap-2 px-4 py-4 active:scale-95"
    >
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current shrink-0"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm5.4 14.1c-.2.7-1.3 1.3-1.9 1.4-.5.1-1.1.1-1.8-.1-.4-.1-1-.3-1.7-.6-3-1.3-4.9-4.3-5.1-4.5-.1-.2-1.2-1.6-1.2-3s.7-2.1 1-2.4c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.4l.9 2.1c.1.2.1.4 0 .6l-.4.6c-.1.2-.3.4-.1.7.1.3.7 1.1 1.5 1.8 1 .9 1.9 1.2 2.1 1.3.3.1.5.1.6-.1l.8-1c.2-.2.4-.2.6-.1l2 1c.3.1.5.2.5.4.1.1.1.6-.1 1.2Z"/></svg>
      <span className="max-w-0 overflow-hidden group-hover:max-w-[120px] transition-all duration-300 text-sm font-bold whitespace-nowrap">
        WhatsApp
      </span>
    </a>
  );
}
